export const SELECTED_PROPERTY_UUID_KEY = 'selectedPropertyUuid';
export const FORGOT_PASSWORD_EMAIL_KEY = 'forgotPasswordEmail';
/**
 * Prefix only — always build the real key with {@link roomsPerHousekeeperKey}.
 *
 * INTERIM STORAGE. "Rooms per housekeeper" is a property-level operational
 * constant and belongs on the Property record, computed into the report
 * server-side. It lives in localStorage because the checkouts report ships raw
 * counts and leaves the staffing arithmetic to the browser.
 * See `docs/plans/housekeeper-schedule-backend.md`.
 */
export const ROOMS_PER_HOUSEKEEPER_KEY = 'roomsPerHousekeeper';

/**
 * Scopes the stored value to one property. Without this, a divisor entered for a
 * 12-room boutique silently follows the user to a 200-room hotel and every figure
 * on the report is wrong with no visible cause.
 */
export const roomsPerHousekeeperKey = (propertyId: string): string =>
  `${ROOMS_PER_HOUSEKEEPER_KEY}:${propertyId}`;
